import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Shield, User } from 'lucide-react';

export const UserRoleModal = ({ open, onOpenChange, editingUser, onUpdateUserRole }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Manage User Role</DialogTitle>
          <DialogDescription>
            Update admin permissions for {editingUser?.name}
          </DialogDescription>
        </DialogHeader>

        {editingUser && (
          <div className="space-y-4 py-4">
            <div className="flex items-center gap-3 p-3 rounded-lg bg-muted/50">
              {editingUser.picture && (
                <img
                  src={editingUser.picture}
                  alt={editingUser.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
              )}
              <div>
                <p className="font-medium">{editingUser.name}</p>
                <p className="text-sm text-muted-foreground">{editingUser.email}</p>
              </div>
            </div>

            <div className="space-y-3">
              <Label>Admin Status</Label>
              <div className="space-y-2">
                <Button
                  variant={!editingUser.is_admin ? 'secondary' : 'outline'}
                  className="w-full justify-start"
                  onClick={() => onUpdateUserRole(editingUser.user_id, false, null)}
                  data-testid="make-regular-user"
                >
                  <User className="h-4 w-4 mr-2" />
                  Regular User (Explorer)
                </Button>
                <Button
                  variant={
                    editingUser.is_admin && editingUser.admin_role === 'moderator'
                      ? 'secondary'
                      : 'outline'
                  }
                  className="w-full justify-start"
                  onClick={() => onUpdateUserRole(editingUser.user_id, true, 'moderator')}
                  data-testid="make-moderator"
                >
                  <Shield className="h-4 w-4 mr-2" />
                  Moderator (Can manage entities)
                </Button>
                <Button
                  variant={
                    editingUser.is_admin && editingUser.admin_role === 'super_admin'
                      ? 'secondary'
                      : 'outline'
                  }
                  className="w-full justify-start"
                  onClick={() => onUpdateUserRole(editingUser.user_id, true, 'super_admin')}
                  data-testid="make-super-admin"
                >
                  <Shield className="h-4 w-4 mr-2" />
                  Super Admin (Full access)
                </Button>
              </div>

              <div className="text-xs text-muted-foreground space-y-1 p-3 rounded-lg bg-muted/30">
                <p><strong>Moderator:</strong> Can create, edit, verify, and suspend entities</p>
                <p><strong>Super Admin:</strong> Full access including user role management and permanent deletions</p>
              </div>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UserRoleModal;
